// extracted by mini-css-extract-plugin
export var container = "_2y-0";
export var error = "_2y-9";
export var label = "_2y-5";
export var light = "_2y-6";
export var md = "_2y-3";
export var sm = "_2y-2";
export var thin = "_2y-8";
export var thinBold = "_2y-7";
export var vertical = "_2y-4";
export var xs = "_2y-1";